"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monutaTheme = void 0;
exports.monutaTheme = {
    logos: {
        memoresaLogoName: "logo_bright.png",
        memoresaLogotypeName: "logotype_bright.png",
    },
    background: { main: "#f5f5f5" },
    primary: { main: "#731A3EFF", contrast: "#fff" },
    secondary: { main: "#A7B731FF", contrast: "#1f1f1f" },
    navbar: {
        bg: "#731a3e",
        color: "#fff",
        hover: "#eee",
    },
};
